import React from "react";

//Styles
import "./Feedback.scss";

//Components
import RevealOnScroll from "common-components/RevealOnScroll/RevealOnScroll";
import Button from "common-components/Button/Button";
import { ReactComponent as BottomLineSvg } from "assets/how-it-works-bottom.svg";

//Data
import { feedbackStatsExampleData, feedbackExampleData } from "./exampleData";

function Feedback() {
  const { stars, customerReviews } = feedbackStatsExampleData;
  const { picture, pictureAlt, avatar, fullName, mainCitation, fullCitation, designers, entries, budget } = feedbackExampleData;
  return (
    <section className="page-landing feedback">
      <RevealOnScroll>
        <header>
          <h2>Feedback</h2>
          <div className="stars-info">
            <div className="stars">
              {stars + " "}
              <span role="img" aria-label="stars emoji">
                ⭐️
              </span>
            </div>
            <div className="info">
              <span>Overall rating {stars} based on</span>
              <a href="/reviews">{customerReviews} customers reviews</a>
            </div>
          </div>
        </header>
      </RevealOnScroll>
      <RevealOnScroll>
        <p className="subheading">Take our word for it or see what others are saying</p>
      </RevealOnScroll>
      <RevealOnScroll>
        <div className="main-feedback-block m-width-wrapper">
          <div className="col image">
            <img src={picture} alt={pictureAlt} />
          </div>
          <div className="col info">
            <div className="person">
              <img src={avatar} alt={"Avatar for " + fullName} loading="lazy" />
              {fullName}
            </div>
            <blockquote className="main">{mainCitation}</blockquote>
            <blockquote className="full">{fullCitation}</blockquote>
            <div className="numbers">
              <div className="num">
                <span role="img" aria-label="artist emoji">
                  👩‍🎨
                </span>
                {designers} designers
              </div>
              <div className="num">
                <span role="img" aria-label="brush emoji">
                  🖌
                </span>
                {entries} entries
              </div>
              <div className="num">
                <span role="img" aria-label="money emoji">
                  💸
                </span>
                {budget} budget
              </div>
            </div>
          </div>
        </div>
      </RevealOnScroll>
      <Button styleType="primary rounded">Get started</Button>
      <BottomLineSvg className="bottom-line" />
    </section>
  );
}

export default Feedback;
